// removed by extract-text-webpack-plugin
module.exports = {"team-radio":"team-radio","selected":"selected","team-state":"team-state","team-name":"team-name"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/team-radio/team-radio.style.sass
// module id = 5MVB
// module chunks = 0